module.exports = __webpack_public_path__ + "/content/shared/img/tesla/Logo_40x40.png";